import { replaceQueryString } from "@client/lib/api";
import classNames from "classnames";
import md5 from "md5";
import * as React from "react";
import { getInitials } from "./lib";

import "./style.less";

export interface GravatarProps {
  backgroundColor?: string;
  className?: string;
  defaultImage?: string | "mm";
  email: string;
  isRound?: boolean;
  size?: number;

  hideIfErrored?: boolean;

  children?: any;
}

const Gravatar = ({ size = 80, ...props }: GravatarProps) => {
  const [showImg, setShowImg] = React.useState(true);

  const onError = React.useCallback(() => props.hideIfErrored && setShowImg(false), [props.hideIfErrored]);

  return (
    <span
      className={classNames("avatar", props.className, { round: props.isRound })}
      style={{ backgroundColor: props.backgroundColor ?? "var(--color)", width: size, height: size }}
    >
      {props.children}

      {showImg && (
        <img
          src={
            props.email
              ? replaceQueryString(`https://www.gravatar.com/avatar/${md5(props.email)}`, {
                  s: size,
                  d: props.defaultImage || "mm"
                })
              : "#"
          }
          onError={onError}
        />
      )}
    </span>
  );
};
export default Gravatar;

export type GravatarWithNameProps = Omit<GravatarProps, "defaultImage"> & {
  color?: string;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
};
export const GravatarWithName = (props: GravatarWithNameProps) => (
  <Gravatar {...props} defaultImage="404" hideIfErrored>
    <span
      style={{ backgroundColor: props.color, fontSize: (props.size || 80) / 2.5 }}
      className={classNames("placeholder", { round: props.isRound })}
    >
      {getInitials(props)}
    </span>
  </Gravatar>
);
